function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

if (typeof module !== 'undefined' && module.exports) {
    exports = module.exports = __decorate;
}

exports.__decorate = __decorate;


//////////////////
// WEBPACK FOOTER
// ./~/typescript-decorate/index.js
// module id = 24
// module chunks = 0